import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const authHeaders = () => {
  const t = localStorage.getItem("ra_admin_token");
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (typeof e?.msg === "string" ? e.msg.replace("Value error, ", "") : JSON.stringify(e))).join(" ");
  if (typeof detail?.msg === "string") return detail.msg;
  return String(detail);
}

export const api = axios;
